import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bulkDeleteTasks, endBulkDeleteTasks } from './store/actions/tasks';
import BulkDeleteModal from 'components/modals/bulk_delete_modal';

export class CallBulkDeleteModal extends React.Component {
  static propTypes = {
    bulkDeleteTasks: PropTypes.bool.isRequired,
    selectedTaskIds: PropTypes.array,
    onBulkDeleteTasks: PropTypes.func.isRequired,
    onCancelBulkDeleteTasks: PropTypes.func.isRequired
  };

  static defaultProps = {
    selectedTaskIds: []
  };

  render() {
    const { bulkDeleteTasks, selectedTaskIds, onCancelBulkDeleteTasks, onBulkDeleteTasks } = this.props;

    return (
      <BulkDeleteModal
        entityCount={selectedTaskIds.length}
        entityName="Calls"
        shown={bulkDeleteTasks}
        onCancel={onCancelBulkDeleteTasks}
        onDelete={onBulkDeleteTasks}
      />
    );
  }
}

const mapStateToProps = state => ({
  bulkDeleteTasks: state.tasks.startBulkDeleteTasks,
  selectedTaskIds: state.selectList.selectedTaskIds
});

const mapDispatchToProps = {
  onBulkDeleteTasks: bulkDeleteTasks,
  onCancelBulkDeleteTasks: endBulkDeleteTasks
};

export default connect(mapStateToProps, mapDispatchToProps)(CallBulkDeleteModal);
